export const VISIBLE_STEPS = [
  { key: 'Integration', label: 'Prerender Integration' },
  { key: 'robots.txt', label: 'Robots.txt' },
  { key: 'CDN', label: 'CDN Configuration' },
  { key: 'WAF', label: 'Web Application Firewall' },
] as const;

export type DiagnosticsStep = (typeof VISIBLE_STEPS)[number];

export function getCompletedStepKeys(checks: Partial<Record<string, boolean>>): string[] {
  return VISIBLE_STEPS.filter((step) => checks[step.key] === true).map((step) => step.key);
}
